import axios from "axios";
import {
  Toast
} from "vant";
import {
  apiBaseUrl,
  appkeyValue
} from "@/utils/common";
import router from "@/router";
import signMd5Utils from "../utils/signMd5Utils";

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: apiBaseUrl,
  // 超时
  timeout: 60000,
  xhrFields: {
    withCredentials: false
  },
  crossDomain: true,
  emulateJSON: true
});

// request拦截器
service.interceptors.request.use(config => {
  let token = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).token : null;
  if (token) {
    config.headers.Authorization = token;
  }

  if (!config.onlyParams) {
    // 获取signature --将接口的参数排序拼接并加上appSecretKey后进行MD5加密
    let urlValue = JSON.parse(JSON.stringify(config.url));
    let signValue = signMd5Utils.getSign(urlValue, config.params || {});

    // 判断metaValue是否存在 有的话就传参 没有的话传空字符串 此值相当于meta参数 用于前后端联调
    let noncestrValue = config.metaValue || "";

    // 将signature timestamp appkey noncestr进行合并作为链接传参 此项目并没有请求体data传参
    let baseObj = {
      "signature": signValue,
      "timestamp": Math.ceil(Date.now() / 1000),
      "appkey": appkeyValue,
      "noncestr": noncestrValue
    };
    config.params = { ...baseObj, ...config.params };
  }

  // if (config.method === "post") {
  //   if (config.headers["Content-Type"] && config.headers["Content-Type"].includes("application/json")) {
  //     return config;
  //   }
  // }

  return config;
},
error => {
  console.log("request error:" + error);
});

// 响应拦截器
service.interceptors.response.use(function(response) {
  var data = response.data;
  if (!data) {
    Toast("返回数据异常");
  }
  if (data.code == "-10022") {
    console.log("没有访问权限, code:" + data.code);
    Toast("没有访问权限");
    setTimeout(() => {
      // 重定向到登录页面
      localStorage.clear();
      router.push("/login");
    }, 1);
    return false;
  }
  if (data.code == "-100009") {
    Toast("没有访问权限");
    return false;
  }
  if (data) {
    return data;
  }
},
function(error) {
  console.log("response error:" + error);
}
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js